/**
 * GT About split rows — custom JS entry point.
 *
 * Hook into bindRoot() below. Each section instance has [data-gt-about-split].
 * Re-inits on Theme Editor section load (shopify:section:load).
 */
(function () {
  'use strict';

  /**
   * @param {HTMLElement} root — #GtAboutSplit-{id}
   */
  function bindRoot(root) {
    if (!root || root.dataset.gtAboutSplitBound === 'true') return;
    root.dataset.gtAboutSplitBound = 'true';

    // Custom JS: rows, images, text panels, etc.
    // var rows = root.querySelectorAll('.gt-about-split__row');
  }

  function initAll() {
    document.querySelectorAll('[data-gt-about-split]').forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var target = ev.target;
    if (!target || !target.querySelector) return;
    var root = target.querySelector('[data-gt-about-split]');
    if (root) {
      delete root.dataset.gtAboutSplitBound;
      bindRoot(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var target = ev.target;
    if (!target || !target.querySelector) return;
    var root = target.querySelector('[data-gt-about-split]');
    if (!root) return;

    delete root.dataset.gtAboutSplitBound;
    // Teardown listeners / observers here if added in bindRoot.
  });
  

  gsap.registerPlugin(ScrollTrigger);
  const panels = gsap.utils.toArray(".panel-sticky");
  panels.forEach((panel, index) => {
    if (index === panels.length - 1) return;

    ScrollTrigger.create({
        trigger: panel,
        start: "bottom bottom",
        end: "bottom top",
        pin: true,
        pinSpacing: false
    });
  });
})();
